import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Flex, Text } from '@costar/theme-ui';

var _excluded = ["message1", "message2", "message3", "textProps"];
var Placeholder = function Placeholder(props) {
  var _props$message = props.message1,
    message1 = _props$message === void 0 ? 'Select from the list on the left by double clicking.' : _props$message,
    _props$message2 = props.message2,
    message2 = _props$message2 === void 0 ? 'Or' : _props$message2,
    _props$message3 = props.message3,
    message3 = _props$message3 === void 0 ? 'Single click to highlight and use the arrow buttons to move the selection to the list on the right.' : _props$message3,
    textProps = props.textProps,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Flex, _extends({
    flexDirection: "column",
    gap: "lg",
    width: "100%",
    color: "neutral.medium"
  }, rest), message1 && /*#__PURE__*/React.createElement(Text, _extends({
    textAlign: "center"
  }, textProps), message1), message2 && /*#__PURE__*/React.createElement(Text, _extends({
    textAlign: "center"
  }, textProps), message2), message3 && /*#__PURE__*/React.createElement(Text, _extends({
    textAlign: "center"
  }, textProps), message3));
};

export default Placeholder;
//# sourceMappingURL=placeholder.esm.js.map
